// extracted by mini-css-extract-plugin
export default {"DividerContainer":"Divider_DividerContainer__J5-3y","Divider":"Divider_Divider__a867c","TextContainer":"Divider_TextContainer__0slZQ"};